/**
 * A website as a person reads it: its host without www, then its path, so `https://www.agiliosoftware.com/pharmacy/`
 * reads `agiliosoftware.com/pharmacy/`. The path stays because a workspace's website is often one section of its
 * company's site, and the knowledge base agent reads the whole saved address, not just its host (ORB-1064). Query and
 * fragment drop, and a bare `/` is no path. Null for a blank or unreadable website.
 *
 * Parsed here rather than through `normalizeHost`, which checks a domain someone is entering and refuses any `*` or
 * whitespace in the whole value. A saved website the API accepted can carry either in its path or query, and still
 * needs a name.
 */
export function websiteLabel(website: string | null | undefined): string | null {
  const trimmed = website?.trim()
  if (!trimmed) return null
  let url: URL
  try {
    url = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`)
  } catch {
    return null
  }
  const host = url.hostname.toLowerCase().replace(/^www\./, '')
  if (!host.includes('.')) return null
  if (url.pathname === '/') return host
  try {
    return `${host}${decodeURI(url.pathname)}`
  } catch {
    // A malformed escape: show the path as the browser holds it.
    return `${host}${url.pathname}`
  }
}
